import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useContext } from 'react';
import PropTypes from 'prop-types';
import { COMPONENT_QUERY } from './queries';
import { OVContext } from '../../../utils/OVContext';
import { useQuery } from 'urql';
import css from './GiftGuide.module.scss';
import Categories from './Categories';
import GiftCards from './GiftCards';
import GiftsFor from './GiftsFor';
import GiftsForMobile from './GiftsForMobile';
import Help from './Help';
import Hero from './Hero';
import Spinner from '../../../components/icons/Spinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var GiftGuide = function GiftGuide(_ref) {
  var categories = _ref.categories,
      giftCards = _ref.giftCards,
      giftsForHer = _ref.giftsForHer,
      giftsForHim = _ref.giftsForHim,
      help = _ref.help,
      hero = _ref.hero;

  var _useContext = useContext(OVContext),
      mobileLarge = _useContext.mobileLarge,
      tabletSmall = _useContext.tabletSmall;

  var _useQuery = useQuery({
    query: COMPONENT_QUERY,
    variables: {
      id: categories.idEMS
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      error = _useQuery2$.error,
      fetching = _useQuery2$.fetching,
      data = _useQuery2$.data;

  if (error) {
    console.error(error);
  }

  if (fetching || error) {
    return /*#__PURE__*/_jsx("div", {
      className: css.fetching,
      children: /*#__PURE__*/_jsx(Spinner, {})
    });
  }

  var component = data.component;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx(Hero, _objectSpread(_objectSpread({}, hero), {}, {
      image: tabletSmall ? hero.imageMobile : hero.image
    })), !tabletSmall && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(GiftsFor, _objectSpread(_objectSpread({}, giftsForHer), {}, {
        flipped: true
      })), /*#__PURE__*/_jsx(GiftsFor, _objectSpread({}, giftsForHim))]
    }), tabletSmall && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(GiftsForMobile, _objectSpread(_objectSpread({}, giftsForHer), {}, {
        image: giftsForHer.imageMobile
      })), /*#__PURE__*/_jsx(GiftsForMobile, _objectSpread(_objectSpread({}, giftsForHim), {}, {
        flipped: true,
        image: giftsForHim.imageMobile
      }))]
    }), component && /*#__PURE__*/_jsx(Categories, _objectSpread(_objectSpread({}, categories), {}, {
      component: component,
      image: mobileLarge ? categories.imageMobile : categories.image
    })), /*#__PURE__*/_jsx(GiftCards, _objectSpread({}, giftCards)), /*#__PURE__*/_jsx(Help, {
      items: help,
      isMobile: tabletSmall
    })]
  });
};

GiftGuide.propTypes = {
  categories: PropTypes.shape({
    idEMS: PropTypes.string,
    image: PropTypes.shape({}),
    imageMobile: PropTypes.shape({})
  }).isRequired,
  giftCards: PropTypes.shape({}).isRequired,
  giftsForHer: PropTypes.shape({
    imageMobile: PropTypes.shape({})
  }),
  giftsForHim: PropTypes.shape({
    imageMobile: PropTypes.shape({})
  }),
  help: PropTypes.arrayOf(PropTypes.shape({})),
  hero: PropTypes.shape({
    imageMobile: PropTypes.shape({}),
    image: PropTypes.shape({})
  }).isRequired
};
export default GiftGuide;